// removed by extract-text-webpack-plugin
module.exports = {"Button__small___1mUB3":"Button__small___1mUB3","Button__medium___GQjew":"Button__medium___GQjew","Button__large___27Jt8":"Button__large___27Jt8","Button__button___3Jloz":"Button__button___3Jloz","Button__isDangerousAction___1ZqcB":"Button__isDangerousAction___1ZqcB"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/Button/buyer/Primary.css
// module id = ./node_modules/dibs-elements/dist/Button/buyer/Primary.css
// module chunks = 4